<template>
  <div id="conteneur-clavardage" class="conteneur-clavardage" />
</template>

<script>
import i18n from '@/js/i18n';

export default {
  name: 'IframeHtmlSalesforce',
  props: { positionBulle: { type: String } },
  mounted() {
    // on prend la position définie si elle existe, sinon on prend 90 par défaut.
    // eslint-disable-next-line no-undef
    recupererClavardage(i18n.locale, this.positionBulle || '90');
  },
};
</script>
